var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.95015 10.9269H9.54091C9.81154 10.9269 10.036 10.7002 10.036 10.4269C10.036 10.1535 9.81154 9.93355 9.54091 9.93355H5.95015C5.67953 9.93355 5.45511 10.1535 5.45511 10.4269C5.45511 10.7002 5.67953 10.9269 5.95015 10.9269ZM8.18118 6.60017H5.95015C5.67953 6.60017 5.45511 6.82684 5.45511 7.10017C5.45511 7.3735 5.67953 7.5935 5.95015 7.5935H8.18118C8.4518 7.5935 8.67623 7.3735 8.67623 7.10017C8.67623 6.82684 8.4518 6.60017 8.18118 6.60017ZM12.8917 6.01724C13.0469 6.01545 13.2158 6.0135 13.3693 6.0135C13.5343 6.0135 13.6663 6.14683 13.6663 6.3135V11.6735C13.6663 13.3268 12.3396 14.6668 10.7026 14.6668H5.44852C3.73235 14.6668 2.33301 13.2602 2.33301 11.5268V4.34016C2.33301 2.68683 3.66634 1.3335 5.3099 1.3335H8.83466C9.00627 1.3335 9.13829 1.4735 9.13829 1.64016V3.78683C9.13829 5.00683 10.135 6.00683 11.3429 6.0135C11.6251 6.0135 11.8738 6.01561 12.0915 6.01745C12.2608 6.01889 12.4114 6.02016 12.5442 6.02016C12.6382 6.02016 12.76 6.01876 12.8917 6.01724ZM13.0733 5.0443C12.5308 5.0463 11.8912 5.0443 11.4311 5.03963C10.7011 5.03963 10.0997 4.4323 10.0997 3.69497V1.93763C10.0997 1.6503 10.445 1.50763 10.6423 1.71497C10.9999 2.09046 11.4914 2.60674 11.9805 3.12054C12.4674 3.63206 12.952 4.14111 13.2998 4.5063C13.4925 4.7083 13.3512 5.04363 13.0733 5.0443Z",
    fill: "#6C5DD3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetails);
export default __webpack_public_path__ + "static/media/details.fe282589bb2953881bcbb3319a7efcd8.svg";
export { ForwardRef as ReactComponent };